// extracted by mini-css-extract-plugin
export default {"container":"dadosChat_container__hEa7w","documentButton":"dadosChat_documentButton__VhYhG","title":"dadosChat_title__DxZA5"};